import React from 'react'
import PropTypes from 'prop-types'

const TwoColumnIcon = ({ size = 20, color = '#fff', strokeColor = '#000' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 20 20"
      fill={color}
      xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_7757_61)" stroke={strokeColor} strokeWidth={0.75}>
        <rect x={0.375} y={0.375} width={8.75} height={8.75} rx={0.625} />
        <rect x={0.375} y={10.875} width={8.75} height={8.75} rx={0.625} />
        <rect x={10.875} y={10.875} width={8.75} height={8.75} rx={0.625} />
        <rect x={10.875} y={0.375} width={8.75} height={8.75} rx={0.625} />
      </g>
      <defs>
        <clipPath id="clip0_7757_61">
          <path fill={color} d="M0 0H20V20H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}

TwoColumnIcon.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  strokeColor: PropTypes.string,
}

export default React.memo(TwoColumnIcon)
